(() => {
  if (window.LsRegion) return;
  /* Country picker: the native select stays as the no-JS control; with JS a button opens a searchable
     listbox (popover beside the trigger, bottom sheet on phones) built from the select's options on first open. */
  const sheetMq = matchMedia('(max-width:640px)');
  const fold = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  function bindRegion(region, signal) {
    const form = region.closest('form');
    const select = region.querySelector('[data-ls-region-select]');
    const btn = region.querySelector('[data-ls-region-btn]');
    const panel = form.querySelector('[data-ls-rp]');
    const scrim = form.querySelector('.ls-rp-scrim');
    const search = panel?.querySelector('[data-ls-rp-search]');
    const list = panel?.querySelector('[data-ls-rp-list]');
    const none = panel?.querySelector('[data-ls-rp-none]');
    if (!select || !btn || !panel || !list || region.dataset.lsRpBound) return;
    region.dataset.lsRpBound = '1';
    select.addEventListener('change', () => form.submit(), { signal });
    region.classList.add('is-enhanced');
    btn.hidden = false;
    let rows = [];
    let active = -1;

    function build() {
      if (rows.length) return;
      const frag = document.createDocumentFragment();
      Array.from(select.options).forEach((o, i) => {
        const li = document.createElement('li');
        li.id = `${list.id}-${o.value}`;
        li.className = 'ls-rp-row';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', String(o.selected));
        li.dataset.code = o.value;
        const name = o.dataset.name || o.textContent.trim();
        const cur = o.dataset.cur || '';
        li.innerHTML = '<span class="ls-rp-code" aria-hidden="true"></span><span class="ls-rp-name"></span><span class="ls-rp-cur"></span><span class="ls-rp-tick" aria-hidden="true"></span>';
        li.children[0].textContent = o.value;
        li.children[1].textContent = name;
        li.children[2].textContent = cur;
        li.dataset.key = fold(`${name} ${o.value} ${cur}`);
        frag.appendChild(li);
        rows.push(li);
        if (o.selected) li.classList.add('is-current');
      });
      list.appendChild(frag);
    }

    const visible = () => rows.filter((r) => !r.hidden);

    function setActive(row, scroll = true) {
      rows.forEach((r) => r.classList.remove('is-active'));
      if (!row) { search.removeAttribute('aria-activedescendant'); active = -1; return; }
      row.classList.add('is-active');
      search.setAttribute('aria-activedescendant', row.id);
      active = rows.indexOf(row);
      if (scroll) row.scrollIntoView({ block: 'nearest' });
    }

    function filter() {
      const q = fold(search.value.trim());
      let first = null;
      rows.forEach((r) => {
        r.hidden = !!q && !r.dataset.key.includes(q);
        if (!r.hidden && !first) first = r;
      });
      none.hidden = !!first;
      setActive(q ? first : rows.find((r) => r.classList.contains('is-current')) || first);
    }

    function place() {
      panel.removeAttribute('data-side');
      panel.removeAttribute('data-align');
      if (sheetMq.matches) return;
      const r = region.getBoundingClientRect();
      const roomAbove = r.top;
      const roomBelow = innerHeight - r.bottom;
      if (roomAbove < 320 && roomBelow > roomAbove) panel.dataset.side = 'below';
      if (panel.getBoundingClientRect().right > document.documentElement.clientWidth - 12) panel.dataset.align = 'end';
    }

    function open() {
      build();
      search.value = '';
      rows.forEach((r) => { r.hidden = false; });
      none.hidden = true;
      panel.hidden = false;
      if (scrim) scrim.hidden = !sheetMq.matches;
      place();
      btn.setAttribute('aria-expanded', 'true');
      form.classList.add('is-open');
      if (sheetMq.matches) document.documentElement.classList.add('ls-rp-lock');
      const cur = rows.find((r) => r.classList.contains('is-current'));
      requestAnimationFrame(() => {
        if (cur) { list.scrollTop = cur.offsetTop - list.clientHeight / 2 + cur.offsetHeight / 2; setActive(cur, false); }
        search.focus({ preventScroll: true });
      });
    }

    function close(focus = true) {
      if (panel.hidden) return;
      panel.hidden = true;
      if (scrim) scrim.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      form.classList.remove('is-open');
      document.documentElement.classList.remove('ls-rp-lock');
      if (focus) btn.focus({ preventScroll: true });
    }

    function pick(row) {
      if (!row) return;
      if (row.classList.contains('is-current')) return close();
      rows.forEach((r) => r.setAttribute('aria-selected', String(r === row)));
      row.classList.add('is-busy');
      panel.setAttribute('aria-busy', 'true');
      select.value = row.dataset.code;
      form.submit();
    }

    btn.addEventListener('click', () => (panel.hidden ? open() : close()), { signal });
    search.addEventListener('input', filter, { signal });
    list.addEventListener('click', (e) => pick(e.target.closest('.ls-rp-row')), { signal });
    list.addEventListener('pointermove', (e) => {
      const row = e.target.closest('.ls-rp-row');
      if (row && !row.classList.contains('is-active')) setActive(row, false);
    }, { signal });
    form.querySelectorAll('[data-ls-rp-close]').forEach((el) => el.addEventListener('click', () => close(), { signal }));
    panel.addEventListener('keydown', (e) => {
      const vis = visible();
      const i = vis.indexOf(rows[active]);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!vis.length) return;
        const next = e.key === 'ArrowDown' ? Math.min(vis.length - 1, i + 1) : Math.max(0, i - 1);
        setActive(vis[i < 0 ? 0 : next]);
      } else if (e.key === 'Home' && e.target !== search) {
        e.preventDefault(); setActive(vis[0]);
      } else if (e.key === 'End' && e.target !== search) {
        e.preventDefault(); setActive(vis[vis.length - 1]);
      } else if (e.key === 'Enter') {
        e.preventDefault(); pick(rows[active]);
      } else if (e.key === 'Escape') {
        e.preventDefault(); close();
      } else if (e.key === 'Tab') {
        const f = Array.from(panel.querySelectorAll('button, input'));
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    }, { signal });
    document.addEventListener('pointerdown', (e) => {
      if (!panel.hidden && !panel.contains(e.target) && !region.contains(e.target)) close(false);
    }, { signal });
    addEventListener('resize', () => { if (!panel.hidden) { if (scrim) scrim.hidden = !sheetMq.matches; place(); } }, { signal, passive: true });
    sheetMq.addEventListener('change', () => close(false), { signal });
  }

  let ac = null;
  function init() {
    if (ac) ac.abort();
    ac = new AbortController();
    document.querySelectorAll('[data-ls-region]').forEach((el) => { delete el.dataset.lsRpBound; bindRegion(el, ac.signal); });
  }
  window.LsRegion = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
